// One place to describe what you offer. Edit this file, not the components.

// ---- Logos --------------------------------------------------------------
// Drop official logo files into  public/payment-logos/  using these names
// (png, or change the extension below). Until a file exists, the component
// falls back to a plain text chip, so nothing looks broken. The chip colours
// are placeholders, not official brand assets.
export const PAYMENT_LOGOS = {
  mpesa:       { label: 'M-Pesa',       src: '/payment-logos/mpesa.png',       chip: { text: 'M-PESA',  bg: '#2e9e44', color: '#fff' } },
  tigopesa:    { label: 'Tigo Pesa',    src: '/payment-logos/tigopesa.png',    chip: { text: 'TIGO PESA', bg: '#00377b', color: '#fff' } },
  airtelmoney: { label: 'Airtel Money', src: '/payment-logos/airtelmoney.png', chip: { text: 'AIRTEL MONEY', bg: '#e40000', color: '#fff' } },
  halopesa:    { label: 'HaloPesa',     src: '/payment-logos/halopesa.png',    chip: { text: 'HALOPESA', bg: '#f26522', color: '#fff' } },
  visa:        { label: 'Visa',         src: '/payment-logos/visa.png',        chip: { text: 'VISA',    bg: '#1a1f71', color: '#fff' } },
  mastercard:  { label: 'Mastercard',   src: '/payment-logos/mastercard.png',  chip: { text: 'MASTERCARD', bg: '#eb001b', color: '#fff' } },
};

// ---- Options shown in the cart ------------------------------------------
// `id` must match what Cart.jsx expects: 'clickpesa' | 'pesapal'.
// `logos` lists the methods each gateway accepts; trim it to what is actually
// enabled on your ClickPesa / Pesapal accounts.
export const PAYMENT_OPTIONS = [
  {
    id: 'clickpesa',
    title: 'Mobile money prompt',
    description: 'We send a prompt to your phone. Approve it with your PIN.',
    logos: ['tigopesa', 'airtelmoney', 'halopesa'],
    badge: 'Active: TZ Only',
  },
  {
    id: 'pesapal',
    title: 'Card or mobile money',
    description: 'Pay on Pesapal\u2019s secure page.',
    logos: ['visa', 'mastercard', 'mpesa', 'tigopesa', 'airtelmoney'],
    badge:'Not Activated',
  },
];
